<template>
  <div>
    <div class="makbuz" id="Yazdir">
      <div class="header" v-html="data.Bilgi.Makbuz"></div>
      <hr v-if="data.Bilgi.Makbuz">
      <div class="Detay">
        <table class="table">
          <thead>
          <tr>
            <th>Borç Tarihi</th>
            <th>Borç Türü</th>
            <th>Açıklama</th>
            <th class="text-right">Mahsup Tutar</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="Borc in data.Borc">
            <td>{{Borc.sTarihi}}</td>
            <td>{{Borc.Kategori}}</td>
            <td>{{Borc.Aciklama}}</td>
            <td class="text-right">{{Borc.Tutar}}</td>
          </tr>
          </tbody>
        </table>

        <p style="font-size: 12px;font-weight: bold">{{data.Bilgi.BinaAdi}} adına {{data.Bilgi.oTarihi}} tarihinde
          {{data.Bilgi.Kasa}} {{data.Bilgi.Tur==3?'kasasından':'kasasına'}}, <br>{{data.Bilgi.Cari.Unvan}} {{data.Bilgi.OdemeTutar}} TL ödeme
          {{data.Bilgi.Tur==3?'yapılmıştır':'alınmıştır'}}.</p>
        <em v-if="data.Bilgi.Aciklama"><b>Makbuz Açıklama:</b> {{data.Bilgi.Aciklama}}</em>
      </div>
      <div class="Bilgi">
        <table class="table">
          <thead>
          <tr>
            <th colspan="2" class="text-center">{{data.Bilgi.TurText}}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Bina Adı</td>
            <td class="text-right">{{data.Bilgi.BinaAdi}}</td>
          </tr>
          <tr>
            <td>Makbuz No</td>
            <td class="text-right">{{data.Bilgi.mNo}}</td>
          </tr>
          <tr>
            <td>Kasa</td>
            <td class="text-right">{{data.Bilgi.Kasa}}</td>
          </tr>
          <tr>
            <td>Ödeme Tarihi</td>
            <td class="text-right">{{data.Bilgi.oTarihi}}</td>
          </tr>
          <tr>
            <td>İşlem Zamanı</td>
            <td class="text-right">{{data.Bilgi.iTarihi}}</td>
          </tr>
          <tr v-if="data.BankaDokum">
            <td>Banka Referans No</td>
            <td class="text-right">{{data.BankaDokum.Referans}}</td>
          </tr>
          <tr>
            <td>Ödenen</td>
            <td class="text-right"><b>{{data.Bilgi.OdemeTutar}} TL</b></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="makbuzaltimza float-left">
        <b>Teslim {{data.Bilgi.Tur==4?'Eden':'Alan'}}</b><br>
        <small>{{data.Bilgi.Cari.Unvan}} adına<br>İmza</small>
      </div>
      <div class="makbuzaltimza float-right">
        <b>Teslim {{data.Bilgi.Tur==4?'Alan':'Eden'}}</b><br>
        <small>{{data.Bilgi.BinaAdi}} adına {{data.Bilgi.Personel.AdSoyad}}<br>İmza</small>
      </div>
    </div>
  </div>
</template>

<script>


  export default {
    props: ['data'],
    data() {
      return {
        windowRef: null
      };
    },
    watch: {
      open(newOpen) {
        if (newOpen) {
          this.openPortal();
        } else {
          this.closePortal();
        }
      }
    },
    methods: {
      UstBilgi() {
        this.$store.dispatch("Get", {path: 'spesiyal/matbuu/3/1'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.MakbuzUstBilgi = response.Data
            }
          });
      },
      openPortal() {
        this.windowRef = window.open(
          "",
          "",
          "width=800,height=800,left=100,top=100"
        );
        this.windowRef.document.write('<html><head><title>Aidatım Yazıcı</title><link href="https://fonts.googleapis.com/css?family=Google+Sans:700,700i&amp;subset=latin-ext" rel="stylesheet"><link rel="stylesheet" type="text/css" href="https://cdn.mudu.pro/Style/Print/Genel.css"><link rel="stylesheet" type="text/css" href="https://cdn.mudu.pro/Style/Print/Makbuz.css"></head><body>');
        this.windowRef.document.body.appendChild(this.$el);
        this.windowRef.document.write('</body></html>');
        var is_chrome = function () {
          return Boolean(this.windowRef.chrome);
        }
        if (is_chrome) {
          setTimeout(() => {
            this.windowRef.print();
          }, 1000);
          setTimeout(() => {
            this.windowRef.close();
          }, 5000);
        } else {
          setTimeout(() => {
            this.windowRef.print();
          }, 1000);
          this.windowRef.close();
        }
        this.windowRef.addEventListener("beforeunload", this.closePortal);

      },
      closePortal() {
        if (this.windowRef) {
          this.windowRef.close();
          this.windowRef = null;
          this.$emit("close");
        }
      }
    },
    created() {
      this.UstBilgi()
    },
    mounted() {
      if (this.data) {
        this.openPortal();
      }
    },
    beforeDestroy() {
      if (this.windowRef) {
        this.closePortal();
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/Yazdir/FisYazdir.vue